// Normal

export interface IUIState {
    id: string | null;
    popupID?: string;
    params?: any;
    queue?: UIData[];
}

export interface UIData {
    id: string | null;
    popupID?: string;
    params?: any;
}

export const initialUIState: IUIState = {
    id: null,
    popupID: null,
    params: null,
    queue: [],
};
